import { getPath, getInitialState } from "../../utils";
const initialState = {
  activeGenSetting: {},
  activeRule: {},
  finalConfig: [],
  ruleSchema: {},
  levelSchema: {},
  orderSchema: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ACTIVE_GEN_SETTING":
      return setActiveGenSetting(state, action);
    case "SET_ACTIVE_RULE":
      return setActiveRule(state, action);
    case "SET_FINAL_CONFIG":
      return setFinalConfig(state, action);
    case "RESET_STATE_GEN_SETTING":
      return resetState(state, action);
    case "SET_FORM_SCHEMA":
      return setFormschema(state, action);
    default:
      return state;
  }
}

const setActiveRule = (state, action) => {
  return {
    ...state,
    activeRule: action.payload,
  };
};

const setActiveGenSetting = (state, action) => {
  return {
    ...state,
    activeGenSetting: action.payload,
  };
};

const setFinalConfig = (state, action) => {
  return {
    ...state,
    finalConfig: getPath(action.payload, "rules", []),
  };
};

const setFormschema = (state, action) => {
  return {
    ...state,
    ruleSchema: getPath(action.payload, "Rule", {}),
    levelSchema: getPath(action.payload, "Level", {}),
    orderSchema: getPath(action.payload, "Order", {}),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
